import React, { useState } from "react";
import {
  Modal,
  Input,
  Button,
  Typography,
  DatePicker,
  Loading,
  Select,
  RadioGroup,
} from "../../../core";
import { Form, Row, Col, Radio } from "antd";
import { MixStyle } from "../../../styles";
import styled from "styled-components";
import { useForm } from "antd/lib/form/util";
import moment from "moment";
import { addPayment } from "../../../helper/utils/api/payment";
import { getCompanyId } from "../../../helper/utils/companyId";

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const PaymentModal = ({
  paymentModal,
  contractDetails,
  closeModal,
  refreshPayments,
}) => {
  const [form] = useForm();
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = async (fieldsValue) => {
    setIsLoading(true);
    try {
      const companyId = getCompanyId();
      const buyerId =
        contractDetails.buyerCompanyId?._id ||
        contractDetails.buyerCompanyId;

      await addPayment({
        ...fieldsValue,
        payment_date: fieldsValue.payment_date.format("YYYY-MM-DD"),
        contract_id: contractDetails._id,
        contract_type: contractDetails.type || contractDetails.contractType,
        company_id: companyId,
        buyer_id: buyerId,
      });
      form.resetFields();
      closeModalHandler();
      if (refreshPayments) refreshPayments();
    } catch (error) {
      console.log("add payment error", error);
    }
    setIsLoading(false);
  };

  const closeModalHandler = () => closeModal("paymentModal");

  return (
    <Modal
      closable={true}
      visible={paymentModal}
      okText="Add"
      maxwidth="568px"
      footer={false}
      onCancel={closeModalHandler}
      tittle="Add Payment"
    >
      {isLoading ? <Loading /> : null}
      <StyledForm
        form={form}
        {...layout}
        onFinish={onFinish}
        initialValues={{ payment_date: moment() }}
      >
        <Row gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}>
          <Col span={24}>
            <Form.Item
              label="Date"
              name="payment_date"
              rules={[{ required: true, message: "Please set date" }]}
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Amount"
              name="payment_amount"
              rules={[{ required: true, message: "Please enter amount" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Payment Method"
              name="payment_method"
              rules={[{ required: true, message: "Please select method" }]}
            >
              <Select
                placeholder="Payment Method"
                Options={["cash", "cheque"]}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Description" name="description">
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="payment_option"
              label="Payment Status"
              rules={[{ required: true, message: "Please select status" }]}
            >
              <RadioGroup placement="end-to-end">
                <Radio value="paid">Paid</Radio>
                <Radio value="receive">Receive</Radio>
              </RadioGroup>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Row type="flex" justify="center">
              <Col sm={10}>
                <Button bg="#404E67" type="primary" htmlType="submit">
                  <Typography
                    text="Add"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledForm>
    </Modal>
  );
};

export default PaymentModal;
